/**
 * @param props
 */
import lazyScripts from "../services/lazy-scripts";

export default (props) => {
    return {
        form: {
            element: null,
            naming: props.type === '' ? 'FrontendForm' : 'FrontendForm',
            action: window.variables.ajaxUrls[props.type],
            loading: false,
            errors: {
                email: null,
                : null,
                captcha: null,
            },
        },
        google: {
            enabled: window.variables.google.isEnabled,
            loaded: false,
        },
        captcha: {
            container: null,
            loaded: false,
            token: null,
        },
        name: null,
        : null,
        : false,
        async mounted() {
            this.$refs.formElement.addEventListener('submit', (event) => {
                event.stopPropagation();
                event.preventDefault();
                return false;
            });

            if ( this.$refs.googleElement ) {
                lazyScripts.loadGoogle().then(() => {
                    this.google.loaded = true;
                    window.google.s.id.renderButton(this.$refs.googleElement, {...this.$refs.googleElement.dataset});
                });
            }

            if ( this.$refs.captchaElement ) {
                this.captcha.container = document.createElement('div');
                this.captcha.container.className = 'recaptcha-container';
                this.captcha.container.style.display = 'none';
                this.$refs.captchaElement.parentElement.appendChild(this.captcha.container);


                const recaptcha = await lazyScripts.loadRecaptcha();

                const callback = (token) => {
                    this.captcha.token = token;
                    this.submit();
                };


                const widgetId = recaptcha.render(this.captcha.container, {
                    sitekey: window.variables.recaptcha.siteKey,
                    size: 'invisible',
                    callback,
                }, true);

                this.$refs.captchaElement.addEventListener(('ontouchstart' in document.documentElement ? "touchstart" : "click"), (e) => {
                    e.preventDefault();
                    recaptcha.reset(widgetId);
                    recaptcha.execute(widgetId);
                });
            }


        },
        submit() {

            this.form.loading = true;

            const data = {};
            data[this.form.naming] = {
                email: this.name,
                : this.,
                : this.,
                captcha: this.captcha.token,
            };

            fetch(this.form.action,
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    method: "POST",
                    body: JSON.stringify(data)
                })
                .then((data) => {
                    return data.json();
                })
                .then((data) => {
                    this.form.loading = false;
                    if (!data.success) {
                        for (const [key, value] of Object.entries(this.form.errors)) {
                            this.form.errors[key] = data.errors.hasOwnProperty(key) ? data.errors[key] : null;
                        }
                    } else {
                        window.location.reload();
                    }
                })

        },

    }
};